import { bmiStorageKey, defaultBmiState } from "../constants";
import type { BmiCalculatorState } from "../types";

export function loadBmiState(): BmiCalculatorState {
  const savedState = localStorage.getItem(bmiStorageKey);

  if (!savedState) {
    return defaultBmiState;
  }

  try {
    const parsedState = JSON.parse(savedState) as Partial<BmiCalculatorState>;

    return {
      ...defaultBmiState,
      ...parsedState,
      unitSystem: parsedState.unitSystem === "imperial" ? "imperial" : "metric",
      imperialHeightMode: parsedState.imperialHeightMode === "inches" ? "inches" : "feet-inches",
      imperialWeightMode: parsedState.imperialWeightMode === "stones-pounds" ? "stones-pounds" : "pounds"
    };
  } catch {
    localStorage.removeItem(bmiStorageKey);
    return defaultBmiState;
  }
}

export function saveBmiState(state: BmiCalculatorState) {
  localStorage.setItem(bmiStorageKey, JSON.stringify(state));
}
